import { ref, onMounted } from "vue";

export const useIsInIframe = () => {
  const isInIframe = ref(false);

  onMounted(() => {
    try {
      isInIframe.value = window.self !== window.top;
    } catch {
      isInIframe.value = true;
    }
  });

  return isInIframe;
};
